export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "sales",
      layout: "dashboard",
    },
    path: "/sales",
    name: "sales",
    component: () => import("@/layouts/index/SaleIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste de ventes",
          layout: "dashboard",
        },
        path: "index",
        name: "sales-index",
        component: () => import("@/views/sales/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer un vente",
          layout: "dashboard",
        },
        path: "create",
        name: "sales-create",
        component: () => import("@/views/sales/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier la vente",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "sales-edit",
        component: () => import("@/views/sales/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "L'ajout des articles à un vente",
          layout: "dashboard",
        },
        path: "items/create",
        name: "sales-items-create",
        component: () => import("@/views/sales/items/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier les articles d'un vente",
          layout: "dashboard",
        },
        path: ":reference/items/edit",
        name: "sales-items-edit",
        component: () => import("@/views/sales/items/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Valider la vente",
          layout: "dashboard",
        },
        path: ":reference/validated",
        name: "sales-validated",
        component: () => import("@/views/sales/Validated.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails sur la facturation.",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "sales-details",
        component: () => import("@/views/sales/Details.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Ventes (factures) remarquées",
          layout: "dashboard",
        },
        path: "noticed/index",
        name: "sales-noticed-index",
        component: () => import("@/views/sales/Noticed.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Ventes à valider",
          layout: "dashboard",
        },
        path: "tovalidate/index",
        name: "sales-tovalidate-index",
        component: () => import("@/views/sales/ToValidate.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Rapport client",
          layout: "dashboard",
        },
        path: "customer/report",
        name: "sales-customer-report",
        component: () => import("@/views/sales/CustomerReport.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Archive Rapport client",
          layout: "dashboard",
        },
        path: "customer/report/archive",
        name: "sales-customer-report-archive",
        component: () => import("@/views/sales/ArchiveCustomerReport.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Statistiques",
          layout: "dashboard",
        },
        path: "statistics/report",
        name: "sales-statistics-report",
        component: () => import("@/views/sales/Statistics.vue"),
      },
    ],
  },
];
